import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

/**
 * Redirects to the access-denied page when an API call comes back 401
 * (not authenticated) or 403 (authenticated but forbidden).
 * The error is re-thrown so per-call handlers (store/dialog) still see it.
 */
export const accessDeniedInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  return next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse && (err.status === 401 || err.status === 403)) {
        void router.navigate(['/access-denied']);
      }
      return throwError(() => err);
    })
  );
};
